document.addEventListener('DOMContentLoaded', function() {
  var $filmstripInner2 = jQuery(".expert-filmstrip-inner2");
  var $clonedContent2 = $filmstripInner2.html();
  $filmstripInner2.append($clonedContent2); // Duplicate for seamless loop

  const $deviceComparo = $("#deviceComparo1");
  const $scrollbarThumb = $(".custom-scrollbar-thumb");

  /*function updateScrollbar() {
    const isMobile = $(window).width() <= 768;
    const $table = $(".actualComparisonTable");
    const marginLeft = parseFloat($table.css("margin-left")) || 0;
    const scrolled = -marginLeft;
    if (isMobile) {
      const maxScroll = 2997;
    } else {
      const maxScroll = 2997; // known max scroll distance on desktop
    }
    const thumbWidth = (scrolled / maxScroll) * 100;

    const minWidth = $(window).width() <= 768 ? 25 : 10;
    $scrollbarThumb.css("width", `${Math.max(thumbWidth, minWidth)}%`);
  }*/

  function updateScrollbar() {
    const isMobile = $(window).width() <= 1024;
    const $table = $(".actualComparisonTable");
    const marginLeft = parseFloat($table.css("margin-left")) || 0;
    const scrolled = -marginLeft;

    // Calculate maxScroll dynamically or set it based on device
    const maxScroll = isMobile
      ? $(window).width() * 2 - $(window).width() * 1.1 // 200vw - 88vw
      : 3996 - 999; // contentWidth - containerWidth for desktop

    //const thumbWidth = (scrolled / maxScroll) * 100;
    const thumbWidth = Math.min((scrolled / maxScroll) * 100, 100);
    const minWidth = isMobile ? 50 : 10;

    $scrollbarThumb.css("width", `${Math.max(thumbWidth, minWidth)}%`);
  }

  // Initialize the scrollbar thumb
  updateScrollbar();

  $deviceComparo.on("scroll", updateScrollbar);

  /*let position = 0;
  const step = 999;
  const containerWidth = 999;
  const contentWidth = 3996;
  const maxScroll = contentWidth - containerWidth;
  let currentPage = 0;
  const totalCols = 12;
  const visibleCols = 3;
  const maxPage = Math.floor((totalCols - 1) / visibleCols); // = 3 (pages 0 to 3)
  */
  let position = 0;
  let currentPage = 0;
  let step, containerWidth, contentWidth, visibleCols, maxPage;

  function updateDimensions() {
    const isMobile = $(window).width() <= 1024;
    const isMobileNotInUse = "yeah";
    const totalCols = 28;

    if (isMobileNotInUse !== "yeah") {
      step = $(window).width() * 0.96; // 88vw
      containerWidth = step;
      contentWidth = $(window).width() * 2; // 200vw
      visibleCols = 2;
      maxPage = 1; // Mobile: only 2 pages (0 and 1)
    } else {
      step = 999;
      containerWidth = 999;
      contentWidth = 3996;
      visibleCols = 3;
      maxPage = Math.floor((totalCols - 1) / visibleCols);
    }
  }

  function getCurrentPage() {
    // get the numeric margin
    const ml = parseFloat($(".actualComparisonTable").css("margin-left")) || 0;

    // how many pixels make up one page?
    const pageWidth = step / visibleCols;

    // how many “pages” have we shifted?
    return Math.round(-ml / pageWidth);
  }
  window.getCurrentPage = getCurrentPage;

  // jump to an arbitrary page (0-based)
  window.gotoComparoPage = function (page) {
    // clamp to [0…maxPage]
    currentPage = Math.max(0, Math.min(page, maxPage));
    updatePosition();
    updateScrollbar();
    console.log(page);
  };

  // convenience shortcuts
  window.nextComparoPage = function () {
    if (currentPage < maxPage) {
      currentPage++;
      updatePosition();
      updateScrollbar();
    }
  };
  window.prevComparoPage = function () {
    if (currentPage > 0) {
      currentPage--;
      updatePosition();
      updateScrollbar();
    }
  };

  /*function updateVisibleColumns() {
    const visibleCols = 3;
    const start = position / step;
    const end = start + visibleCols;

    $(".actualComparisonTable tr").each(function () {
      const $cells = $(this).children("td");
      $cells.each(function (i) {
        if (i >= start && i < end) {
          //$(this).css("visibility", "visible");
          $(this).css("display", "visible");
        } else {
          //$(this).css("visibility", "hidden");
          $(this).css("display", "none");
        }
      });
    });
  }*/
  function updateVisibleColumns() {
    const isMobile = window.innerWidth < 1024;
    const visibleCols = isMobile ? 2 : 3;
    const maxVisibleIndex = (currentPage + 1) * visibleCols;

    $(".actualComparisonTable tr").each(function () {
      $(this)
        .children("td")
        .each(function (i) {
          if (i < maxVisibleIndex) {
            //$(this).css("display", isMobile ? "inline-block" : "table-cell");
            $(this).css("display", isMobile ? "table-cell" : "table-cell");
          } else {
            $(this).css("display", "none");
          }
        });
    });
  }

  $(window).on("resize", updateVisibleColumns);

  function updateButtons() {
    //$("#prevBtn").toggle(currentPage > 0);
    $("#prevBtn")
      .toggle(currentPage > 0)
      .toggleClass("is-visible", currentPage > 0);
    $("#nextBtn").toggle(currentPage < maxPage);
  }

  function updatePosition() {
    //position = currentPage * step;
    const position = currentPage * (step / 3);
    $(".actualComparisonTable").css("margin-left", `-${position}px`);
    updateButtons();
    updateVisibleColumns();
  }

  $("#nextBtn").click(function () {
    if (currentPage < maxPage) {
      currentPage++;
      updatePosition();
      updateScrollbar();
    }
  });

  $("#prevBtn").click(function () {
    if (currentPage > 0) {
      currentPage--;
      updatePosition();
      updateScrollbar();
    }
  });

  function isInViewport($el) {
    const rect = $el[0].getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  $(window).on("scroll resize", function () {
    const $scanner = $("#whichScanner");
    const $builtWith = $("#builtWith");
    const $prevBtn = $("#prevBtn.is-visible");
    const $nextBtn = $("#nextBtn");

    if ($(window).width() >= 1024) {
      if (isInViewport($scanner) && !isInViewport($builtWith)) {
        $prevBtn.addClass("fixed-to-left").show();
        $nextBtn.addClass("fixed-to-right").show();
      } else {
        $prevBtn.removeClass("fixed-to-left").hide();
        $nextBtn.removeClass("fixed-to-right").hide();
      }
    } else {
      $prevBtn.removeClass("fixed-to-left").hide();
      $nextBtn.removeClass("fixed-to-right").hide();
    }
  });

  /*$(window).on("resize", function () {
    updateDimensions();

    currentPage = 0;
    position = 0;
    $(".actualComparisonTable").css("margin-left", `-${position}px`);

    updateButtons();
    updateScrollbar();
  });*/
  $(window).on("resize", function () {
    //location.reload();
  });

  // Call once on load
  updateButtons();
  setTimeout(function () {
    updateVisibleColumns();
  }, 500);
  updateDimensions();
  updatePosition();
});

// Tooltip
document.addEventListener('DOMContentLoaded', function() {
  const jsonData = {
    "autoReLink-icon":
      "Auto-Relink automatically re-scans the vehicle at regular intervals, ensuring readiness monitors and key parameters are updated for SMOG testing and emissions compliance.",
    "codePriority-icon":
      "Code Priority refers to identifying the main fault code responsible for triggering your dashboard light. In many cases, resolving the primary fault code can also address related secondary codes that appear afterward.",
    "driveCycleProcedures-icon":
      "Drive Cycle Procedures refers to the ability of guiding you through each specific driving step to reset monitors for SMOG testing with real time instructions.",
    "bidirectionalSystemTest-icon":
      "Bidirectional System Tests let you control vehicle systems to identify issues. Common tests include actuator tests, EVAP system tests, injector balance tests, and solenoid tests.",
    "specialFunctionsRoutinesCalibrations-icon":
      "Special Functions refer to special reset features like SAS, DPF regen, EVAP VSV check, and more.",
    "all10ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 06</strong> - I/M Monitor Tests/Monitoring test results and parameters<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 08</strong> - Request control of Onboard Component<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "all8ObdModes-icon":
      "<strong>Mode 01</strong> - I/M Readiness Status/Live Data Mode (PIDs)<br><strong>Mode 02</strong> - Freeze Frame Data<br><strong>Mode 03</strong> - Emission Related DTCs<br><strong>Mode 04</strong> - Erase DTCs<br><strong>Mode 05</strong> - Request O2 test results<br><strong>Mode 07</strong> - Two Trip Pending Diagnostic Trouble Code<br><strong>Mode 09</strong> - Request vehicle info<br><strong>Mode 10</strong> or <strong>Mode 0a</strong> - Permanent DTC",
    "secureGatewayForFCAvehicles-icon":
      "Secure Gateway access enables select scanners to unlock FCA vehicles' secure gateway by connecting through an AutoAuth account.",
    "batteryTooltip-unused": "Long-lasting battery life for extended usage.",
  };

  let activeTooltip = null;

  // Event delegation for dynamically added elements
  $("body").on("click", ".tooltipForComparo-trigger", function (e) {
    e.stopPropagation();

    // Close any existing tooltip
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }

    const $trigger = $(this);
    const uniqueClass = $trigger
      .attr("class")
      .split(" ")
      .find((cls) => jsonData[cls]);

    const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

    // Create the tooltip dynamically
    const $tooltip = $('<div class="tooltipForComparo"></div>').html(
      tooltipText
    );

    // Append tooltip to the body
    $("body").append($tooltip);

    // Position the tooltip
    const rect = $trigger[0].getBoundingClientRect();
    const left = rect.left + window.scrollX;
    const top = rect.top + window.scrollY - $tooltip.outerHeight() - 10;

    $tooltip.css({
      left: `${left}px`,
      top: `${top}px`,
      display: "block",
    });

    activeTooltip = $tooltip;
  });

  // Close tooltip on outside click
  $(document).on("click", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Close tooltip on scroll
  $("#deviceComparo1").on("scroll", function () {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
    }
  });

  // Handle tooltips inside Bootstrap modals
  $(document).on("shown.bs.modal", function (e) {
    const $modal = $(e.target);

    $modal.on("click", ".tooltipForComparo-trigger", function (e) {
      e.stopPropagation();

      // Close any existing tooltip
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }

      const $trigger = $(this);
      const uniqueClass = $trigger
        .attr("class")
        .split(" ")
        .find((cls) => jsonData[cls]);

      const tooltipText = jsonData[uniqueClass] || "Tooltip not available.";

      // Create the tooltip dynamically
      const $tooltip = $('<div class="tooltipForComparo"></div>').html(
        tooltipText
      );

      // Append tooltip to the modal
      $modal.append($tooltip);

      // Position the tooltip
      const rect = $trigger[0].getBoundingClientRect();
      const left = rect.left;
      const top = rect.top - $tooltip.outerHeight() - 10;

      $tooltip.css({
        left: `${left}px`,
        top: `${top}px`,
        display: "block",
      });

      activeTooltip = $tooltip;
    });

    // Close tooltip on scroll inside the modal
    $modal.on("scroll", function () {
      if (activeTooltip) {
        activeTooltip.remove();
        activeTooltip = null;
      }
    });
  });

  $(document).on(
    "click",
    ".titleDropdown .col-md-4, .titleDropdown .col-md-4 div, .titleDropdown .col-md-4 div img",
    function () {
      //$(this).find("a.dropdown-title").trigger("click");
      const $link = $(this).find("a.dropdown-title");
      const text = $link.text().trim();
      $link.trigger("click");
      var currentPageNumber = getCurrentPage();
      console.log(currentPageNumber);
      setTimeout(() => gotoComparoPage(currentPageNumber), 10);
      if (window.innerWidth < 1024) {
        //$("body").css("overflow", "auto");
        $("body").css("overflow-x", "clip");
        $("body").css("overflow-y", "visible");
      }
      waitForStars();
    }
  );
});

document.addEventListener('DOMContentLoaded', function() { 
  $(window).on("scroll resize", function () {
    $(".titleDropdown").hide();
    $(".productName").removeClass("active-dropdown");
  });


// $.getJSON("//dereksautostaging.myshopify.com/cdn/shop/t/1/assets/ecom-pdp-product-comparo_v2.json",
//   function (data) {
fetch('/pages/products-json') // Adjust URL based on where you put the template
.then(response => response.json())
.then(data => {
    const products = data.products;

    $(document).on(
      "click",
      "#innova-ecom-pdp-template .actualComparisonTable h2.productName",
      function (e) {
        e.stopPropagation();

        const $h2 = $(this);
        const offset = $h2.offset();
        const height = $h2.outerHeight();

        // Toggle behavior
        if ($h2.hasClass("active-dropdown")) {
          $(".titleDropdown").remove();
          $h2.removeClass("active-dropdown");
          return;
        }

        $(".titleDropdown").remove();
        $(".productName").removeClass("active-dropdown");
        $h2.addClass("active-dropdown");

        const $dropdown = $(`
        <div class="titleDropdown row">
          <h3 class="currentSelection mobileVersion"></h3>
          <div class="clear"></div>
          <div class="clear"></div>
          <div class="gradient-overlay mobileVersion">
            <div id="closeOverlay" class="mobileVersion">
              <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="22.5" cy="22.5" r="22.5" fill="black"/>
                <path d="M29.781 28.7198C29.8507 28.7895 29.906 28.8722 29.9437 28.9632C29.9814 29.0543 30.0008 29.1519 30.0008 29.2504C30.0008 29.349 29.9814 29.4465 29.9437 29.5376C29.906 29.6286 29.8507 29.7114 29.781 29.781C29.7114 29.8507 29.6286 29.906 29.5376 29.9437C29.4465 29.9814 29.349 30.0008 29.2504 30.0008C29.1519 30.0008 29.0543 29.9814 28.9632 29.9437C28.8722 29.906 28.7895 29.8507 28.7198 29.781L22.5004 23.5607L16.281 29.781C16.1403 29.9218 15.9494 30.0008 15.7504 30.0008C15.5514 30.0008 15.3605 29.9218 15.2198 29.781C15.0791 29.6403 15 29.4494 15 29.2504C15 29.0514 15.0791 28.8605 15.2198 28.7198L21.4401 22.5004L15.2198 16.281C15.0791 16.1403 15 15.9494 15 15.7504C15 15.5514 15.0791 15.3605 15.2198 15.2198C15.3605 15.0791 15.5514 15 15.7504 15C15.9494 15 16.1403 15.0791 16.281 15.2198L22.5004 21.4401L28.7198 15.2198C28.8605 15.0791 29.0514 15 29.2504 15C29.4494 15 29.6403 15.0791 29.781 15.2198C29.9218 15.3605 30.0008 15.5514 30.0008 15.7504C30.0008 15.9494 29.9218 16.1403 29.781 16.281L23.5607 22.5004L29.781 28.7198Z" fill="white"/>
              </svg>
            </div>
          </div>
        </div>
      `);

        const text = $(this).text().trim();
        $dropdown.find(".currentSelection").text(text);

        // Then insert it wherever it needs to go
        $(this).after($dropdown); // or .appendTo(), .prependTo(), etc.

        products.forEach((product) => {
          const className = product.sku
            .toLowerCase()
            .replace(/\s+/g, "-") // spaces → hyphens
            .replace(/[^a-z0-9\-]/g, ""); // remove non-alphanumerics

          $dropdown.append(`
    <div class="col-6 col-md-4 text-center">
      <div class="innova${className}">
        <img src="${product.image}" alt="${product.sku}" class="img-fluid mb-1">
        <a href="javascript:void(0);" class="dropdown-title d-block">Innova ${product.sku}</a>
      </div>
    </div>
  `);
        });

        const className1 = text
          .toLowerCase()
          .replace(/\s+/g, "")
          .replace(/[^a-z0-9\-]/g, "");

        // Remove from others first if needed
        $("." + className1).addClass("selectedProduct");

        $dropdown.css({
          position: "absolute",
          top: offset.top + height,
          left: offset.left,
        });

        $("body").append($dropdown);

        if (window.innerWidth < 1024) {
          $("body").css("overflow", "hidden");
          $dropdown.css({
            position: "fixed",
            top: "0px",
            left: "0px",
            width: "100vw",
            height: "100vh",
            margin: "0 auto",
          });
        }
      }
    );

    // Click outside to close
    $(document).on("click", "#closeOverlay", function () {
      $(".titleDropdown").remove();
      $(".productName").removeClass("active-dropdown");
      //$("body").css("overflow", "auto");
      $("body").css("overflow-x", "clip");
      $("body").css("overflow-y", "visible");
    });

    // Handle click on product title
    $(document).on("click", ".dropdown-title", function (e) {
      e.preventDefault();
      //const $clickedTitle = $(this).text().trim();
      const $clickedTitle = $(this).text().trim().replace("Innova ", "");
      const $relatedH2 = $(".productName.active-dropdown");
      const colIndex = $(".productName").index($relatedH2);

      $(".comparoProductTitle").eq(colIndex).text($clickedTitle);

      $(".titleDropdown").remove();
      $(".productName").removeClass("active-dropdown");
    });
  }
);

});


// Menu Functions Consolidated
document.addEventListener('DOMContentLoaded', function() {
  $("#mobileMenuButton").click(function () {
    $("#mobileNav").slideToggle();
  });

  $("#mobileNav a").click(function () {
    $("#mobileNav").slideToggle();
  });

  $(".heading-24").click(function () {
    window.scrollTo(0, 0);
  });

  var header = $("#shopify-section-header");
  var headerOffset = header.offset()?.top;

  $(window).on("scroll", function () {
    if ($(window).scrollTop() > headerOffset) {
      //header.addClass("sticky");
    } else {
      //header.removeClass("sticky");
    }
  });

  $(window).on(
    "resize",
    debounce(function () {
      //location.reload();
    }, 250)
  );

  function debounce(func, wait) {
    var timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }

  $(".burger-menu1A").click(function () {
    if ($(".main-content-container1").hasClass("menu-open")) {
      $(".main-content-container1").removeClass("menu-open");
      $(".mobile-menu1B").css("left", "-250px");
      $("body").removeClass("no-scroll"); // Re-enable scrolling
    } else {
      $(".main-content-container1").addClass("menu-open");
      $(".mobile-menu1B").css("left", "0");
      $("body").addClass("no-scroll"); // Disable scrolling
    }
  });

  function toggleMenu(buttonClass, panelId) {
    $(buttonClass).click(function () {
      var $panelCollapse = $(panelId);
      var $icon = $(this).find(".lin");

      // Close any open panels
      $("#pushy-menu .panel-collapse.in")
        .not($panelCollapse)
        .slideUp()
        .removeClass("in");
      $("#pushy-menu .lin-arrow-up")
        .not($icon)
        .removeClass("lin-arrow-up")
        .addClass("lin-arrow-down");

      // Toggle the clicked panel
      if ($panelCollapse.is(":visible")) {
        $panelCollapse.slideUp().removeClass("in");
        $icon.removeClass("lin-arrow-up").addClass("lin-arrow-down");
      } else {
        $panelCollapse.slideDown().addClass("in");
        $icon.removeClass("lin-arrow-down").addClass("lin-arrow-up");
      }
    });

    $("#pushy-menu .lin.lin-arrow-down").on("click", function () {
      $(this).toggleClass("lin-arrow-down lin-arrow-up");
    });
  }

  toggleMenu(
    "#pushy-menu .second_level_drop_link.products_2Button",
    "#pushy-menu #products_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.services_2Button",
    "#pushy-menu #services_2"
  );
  toggleMenu(
    "#pushy-menu .second_level_drop_link.support_4Button",
    "#pushy-menu #support_4"
  );

  // Show dialog and disable vertical scroll
  $("#nav-search-dialog-button").on("click", function () {
    $("#nav-search-dialog").show();
    $("#nav-search-dialog").attr("style", "display: block !important;");
    $("body").css("overflow", "hidden");
  });

  // Hide dialog and enable vertical scroll
  $("#nav-search-dialog-exit").on("click", function () {
    $("#nav-search-dialog").hide();
    $("#nav-search-dialog").attr("style", "display: none !important;");
    //$("body").css("overflow", "auto");
    $("body").css("overflow-x", "clip");
    $("body").css("overflow-y", "visible");
  });

  $(".dropdown-products, .dropdown-support, .dropdown-services").hover(
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").show();
    },
    function () {
      $(this).closest(".dropdown").find(".dropdown-menu").hide();
    }
  );

  $(".dropdown-menu").hover(
    function () {
      $(this).show();
    },
    function () {
      $(this).hide();
    }
  );

  $(".lin.lin-arrow-down").on("click", function () {
    $(this).toggleClass("lin-arrow-down lin-arrow-up");
  });

  $("#closeMobileMenu, .no-scroll").on("click", function () {
    $("#pushy-menu-btn").trigger("click");
  });
});

// Star Ratings
const starFull = "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/one-star.svg";
const starHalf = "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/half-star.svg";
const starBlank = "https://cdn.shopify.com/s/files/1/0266/1302/2766/files/half-star.svg";

function buildStars(rating) {
  const full = Math.floor(rating);
  const half = rating % 1 === 0.5 ? 1 : 0;
  const empty = 5 - full - half;
  let html = "";
  for (let i = 0; i < full; i++)
    html += `<img src="${starFull}" style="width:24px;" alt="star">`;
  if (half)
    html += `<img src="${starHalf}" style="width:24px;" alt="half star">`;
  for (let i = 0; i < empty; i++)
    html += `<img src="${starBlank}" style="width:24px;" alt="blank star">`;
  return html;
}

function processStarRatings(targetSelector = ".detailsRow1") {
  $(`${targetSelector} :contains('generateStars(')`).each(function () {
    const html = $(this).html();
    //const regex = /generateStars\((\d(?:\.5)?),\s*(\d+)\)/g;
    const regex = /generateStars\((\d(?:\.5)|\d(?:\.0*)?),\s*(\d+)\)/g;
    const newHTML = html.replace(regex, (_, rating, count) => {
      const countNum = parseInt(count, 10);
      return `
                <div class="stars" style="display:inline-block;">${buildStars(
                  parseFloat(rating)
                )}</div>
                <div class="review-count">${countNum.toLocaleString()}${
        countNum === 1 ? " review" : "+ reviews"
      }</div>
            `;
    });
    if (newHTML !== html) $(this).html(newHTML);
  });
}

function waitForStars(
  selector = ".detailsRow1",
  delay = 100,
  maxAttempts = 20
) {
  let attempts = 0;
  const interval = setInterval(() => {
    if ($(selector).length) {
      processStarRatings(selector);
      clearInterval(interval);
    } else if (++attempts >= maxAttempts) {
      clearInterval(interval);
      console.warn("Star rating container not found.");
    }
  }, delay);
}

document.addEventListener('DOMContentLoaded', function() {
  waitForStars(); // Wait and trigger on dynamically added .productImagesRow
});

document.addEventListener('DOMContentLoaded', function() {
  // Reset scroll on load
  setTimeout(function () {
    window.scrollTo(0, 0);
  }, 0);

  // Reset scroll on refresh
  $(window).on("beforeunload", function () {
    window.scrollTo(0, 0);
  });
});
